import React, { FC, ReactElement } from 'react';

import styles from './pricingDetailsStyles.scss';

import { Maybe } from '@interfaces/graphql-typings';

const PricingData: FC<{ price: string | JSX.Element; time: Maybe<string> }> = ({
  price,
  time
}): ReactElement => (
  <div>
    <div>{price}</div>
    <div className={styles.priceTime}>{time}</div>
  </div>
);

export default PricingData;
